export default "__VITE_ASSET__9lBRT2Si__"